import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';

// SERVICES
import { EventsService } from 'app/services/events';

@Injectable()
export class AuthGuard implements CanActivate {
  evento: any;
  constructor(
    private auth: AuthService,
    private events: EventsService,
  ) {
    this.evento = events.getEvento();
  }

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.auth.loggedIn().toPromise().then((logado) => {
        if (logado) {
          if (route.url.toString() === 'dashboard') {
            resolve(true);
            return;
          }
          this.auth.permissoes().then((usuario) => {
            if (usuario.admin) {
              return resolve(true);
            }

            const permissoes = JSON.parse(usuario.permissoes);
            if (permissoes[route.url.toString()]) {
              resolve(true);
            } else {
              alert('Sem Autorização!');
              this.evento.emit({ tipo: 'user:login' });
              resolve(false);
            }
          });
        } else {
          // tslint:disable-next-line:no-console
          console.log('Sem login, redirecionando...');
          this.evento.emit({ tipo: 'user:logout' });
          resolve(false);
        }
        return;
      }).catch((error) => {
        // tslint:disable-next-line:no-console
        console.log(error);
        alert('Erro validando acesso!');
        resolve(false);
        return;
      });
    });
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/auth/auth.guard.ts